import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/Constants";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token,
    },
  };
};

export const fetchTopContributors = createAsyncThunk(
  "hallOfFame/fetchTopContributors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/halloffame/top-contributors`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch top contributors"
      );
    }
  }
);

export const fetchAskMeAnything = createAsyncThunk(
  "hallOfFame/fetchAskMeAnything",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/halloffame/ask-me-anything`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Ask Me Anything"
      );
    }
  }
);

export const fetchLeaderboard = createAsyncThunk(
  "hallOfFame/fetchLeaderboard",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/halloffame/leaderboard`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch leaderboard"
      );
    }
  }
);

const hallOfFameSlice = createSlice({
  name: "hallOfFame",
  initialState: {
    topContributors: [],
    askMeAnything: {},
    leaderboard: [],
    topContributorsLastUpdated: null,
    leaderboardLastUpdated: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchTopContributors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTopContributors.fulfilled, (state, action) => {
        state.loading = false;
        state.topContributors = action.payload.data;
        state.topContributorsLastUpdated = action.payload.lastUpdated;
      })
      .addCase(fetchTopContributors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchAskMeAnything.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAskMeAnything.fulfilled, (state, action) => {
        state.loading = false;
        state.askMeAnything = action.payload;
      })
      .addCase(fetchAskMeAnything.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLeaderboard.fulfilled, (state, action) => {
        state.leaderboard = action.payload.data;
        state.leaderboardLastUpdated = action.payload.lastUpdated;
    });
  },
});

export default hallOfFameSlice.reducer;